module.exports = __webpack_public_path__ + "static/media/biometric_design_tab_ok.e031800b.mp4";